import React from 'react';
import { gql } from '@apollo/client';
import { Show, SimpleShowLayout, TextField, FunctionField } from 'react-admin';
import MoneyField from 'components/MoneyField';
import DateTimeField from 'components/DateTimeField';
import { RATE_ADJUSTMENT_CENTS } from 'constants/rateSettings';

const GeneratedRateShow = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField label="Status" source="status" />
        <TextField label="Scope Type" source="scope_type" />
        <TextField label="Scope ID" source="scope_id" />
        <FunctionField label="Position" render={(record) => record?.position?.display_name || ''} />
        <FunctionField label="Specialty" render={(record) => record?.specialty?.label || ''} />
        <FunctionField
          label="New Rate"
          render={(record) => {
            const generatedRate = record?.generated_rate_cents;
            if (!generatedRate) {
              return '';
            }
            return (
              <MoneyField
                source="generated_rate_cents"
                record={{ generated_rate_cents: generatedRate - RATE_ADJUSTMENT_CENTS }}
                blankIfNull
              />
            );
          }}
        />
        <FunctionField
          label="Current Rate"
          render={(record) => {
            const currentRate = record?.current_rate_cents;
            if (!currentRate) {
              return '';
            }
            return (
              <MoneyField
                source="current_rate_cents"
                record={{ current_rate_cents: currentRate - RATE_ADJUSTMENT_CENTS }}
                blankIfNull
              />
            );
          }}
        />
        <TextField label="Variance" source="variance_percent" />
        <DateTimeField label="Deadline" source="review_deadline" />
        <DateTimeField label="Created At" source="created_at" />
      </SimpleShowLayout>
    </Show>
  );
};

GeneratedRateShow.query = gql`
  query autoGeneratedRate($id: Int!) {
    autoGeneratedRate(id: $id) {
      id
      status
      review_deadline
      created_at
      generated_rate_cents
      current_rate_cents
      variance_percent
      scope_type
      scope_id
      position_id
      position {
        id
        display_name
      }
      specialty_id
      specialty {
        id
        label
      }
      last_approved {
        approved_at
        type
      }
      metrics_data {
        gsv_cents_last_45_days
        fill_rate_percentage_last_45_days
        supply_level_category
        supply_utilization_category
        hours_to_fill_last_45_days
      }
    }
  }
`;

export default GeneratedRateShow;
